<template>
  <div id="app">
    <div
      id="nav_mobile"
      v-if="showNavMobile()"
    >
      <div></div>
      <img
        class="search"
        src="@/assets/web_icons/search_icon.png"
        alt="search"
        v-on:click="gotoSearch"
      >
    </div>
    <div id="nav">
      <router-link to="/">
        <img src="@/assets/web_icons/tab/1.png">
        <span>樓宇</span>
      </router-link>
      <router-link to="/wishlist">
        <img src="@/assets/web_icons/tab/2.png">
        <span>心水樓盤</span>
      </router-link>
      <router-link to="/layouts">
        <img src="@/assets/web_icons/tab/3.png">
        <span>樓盤圖則</span>
      </router-link>
      <div
        class="flex-1"
        v-if="isDesktop()"
      ></div>
      <router-link
        to="/search"
        v-if="isDesktop()"
      >
        <img src="@/assets/web_icons/search_icon.png">
        <span>搜尋</span>
      </router-link>
    </div>
    <keep-alive>
      <router-view
        v-if="$route.meta.keepAlive"
        class="main"
      />
    </keep-alive>
    <router-view
      v-if="!$route.meta.keepAlive"
      class="main"
    />
  </div>
</template>

<script>
const showNavMobileRoutes = {
  home: true,
  wishlist: true,
  layouts: false
};
export default {
  name: "app",
  components: {},
  data() {
    return {
      currRoute: "",
      transitionName: ""
    };
  },
  methods: {
    gotoSearch() {
      this.$router.push("/search");
    },
    showNavMobile() {
      return showNavMobileRoutes[this.currRoute];
    },
    isDesktop() {
      return this.$resize && this.$mq.above(769);
    }
  },
  mounted() {
    this.currRoute = this.$route.name;
  },
  watch: {
    $route(to, from) {
      this.currRoute = to.name;
      // const toDepth = to.path.split("/").length;
      // const fromDepth = from.path.split("/").length;
      // this.transitionName = toDepth < fromDepth ? "slide-right" : "slide-left";
    }
  }
};
</script>


<style>
/* animation */
.main {
  will-change: transform;
}
.main > :first-child {
  /* z-index: 1; */
  /* Prevent flickering on first frame when transition classes not added yet */
}

/* Transitions */

.slide-left-leave-to {
  animation: leaveToLeft 200ms both cubic-bezier(0.165, 0.84, 0.44, 1);
  /* z-index: 0; */
}

.slide-left-enter-to {
  animation: enterFromRight 200ms both cubic-bezier(0.165, 0.84, 0.44, 1);
  /* z-index: 1; */
}

.slide-right-leave-to {
  animation: leaveToRight 200ms both cubic-bezier(0.165, 0.84, 0.44, 1);
  /* z-index: 1; */
}

.slide-right-enter-to {
  animation: enterFromLeft 200ms both cubic-bezier(0.165, 0.84, 0.44, 1);
  /* z-index: 0; */
}

@keyframes leaveToLeft {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-100%);
    /* filter: brightness(0.5); */
  }
}

@keyframes enterFromLeft {
  from {
    transform: translateX(-100%);
    /* filter: brightness(0.5); */
  }
  to {
    transform: translateX(0);
  }
}

@keyframes leaveToRight {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(100%);
  }
}

@keyframes enterFromRight {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}
</style>


<style lang="scss">
#app {
  min-height: 100vh;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0;
  background-color: #f0eff4;
}
#nav_mobile {
  display: none;
  height: 56px;
  padding: 0 8px;
  background-color: #fff;
  > img.search {
    cursor: pointer;
    height: 28px;
  }
}
#nav {
  background-color: white;
  height: 81px !important;
  padding: 0.5rem 1rem;
  box-sizing: border-box;
  display: flex;
  position: relative !important;
  z-index: 5;
  border-bottom: 1px solid rgb(228, 228, 228) !important;
  justify-content: flex-start;
  align-items: center;
  > a {
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0.8;
    height: 100%;
    text-decoration: none;
    color: #484848;
    padding: 16px;
    &:hover {
      opacity: 1;
    }
    &.router-link-exact-active {
      font-weight: bold;
      opacity: 1;
    }
    > img {
      height: 1rem;
    }
    > span {
      margin-left: 8px;
    }
  }
}

@media (max-width: 768px) {
  #nav_mobile {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  #nav {
    padding: 0 1rem;
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.5);
    position: fixed !important;
    width: 100vw;
    justify-content: space-around;
    bottom: 0px;
    height: 56px !important;
    > a {
      flex: 1;
      box-sizing: border-box;
      padding: 0;
      padding-top: 0.5rem;
      transition: transform 20ms linear;
      &.router-link-exact-active {
        color: rgb(66, 66, 255);
        transform: translateY(-2px);
      }
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      > img {
        height: 24px;
      }
      > span {
        font-size: 0.85rem;
        margin-left: 0;
      }
    }
  }
  .main {
    padding-bottom: 58px !important;
  }
}
body {
  margin: 0;
}
</style>
